// export const baseUrl = "https://www.fineoutput.co.in/motoconcept2/Apicontroller/";
// export const baseUrl = "http://localhost/motoconcept2/Apicontroller/";
// export const baseUrl = "https://motoconcept.in/backend/Apicontroller/";
export const baseUrl = "https://www.motoconcept.in/backend/Apicontroller/";
